import React from 'react';
import classNames from 'classnames';
import styles from './index.less';

const ModalMask = ({ transparent, id }) => (
  <div
    id={id}
    className={
      classNames(
        styles.modalMask,
        { [styles.transparent]: transparent },
      )
    }
  />
);

export default ModalMask;

ModalMask.defaultProps = {
  id: '',
  transparent: false,
};
